<template>
  <div class="main">
    <div v-if="status">
      <div>
        <div>
          <div v-html="announcements.content"></div>
        </div>
      </div>
      <ul class="database">
        <li v-for="(values,index) in all_data" :key="index">
          <p class="grouping" v-html="values.name"></p>
          <div class="dbs">
            <span v-for="(value,ind) in values.twos" :key="ind">
              <el-link :href="value.url" target="_blank" class="menu link" :underline="false" v-if="value.url"
                       v-html="value.name">
              </el-link>
              <span v-if="value.threes" class="menu">
                <el-dropdown placement="bottom" :show-timeout=0 @command="link">
                  <span class="el-dropdown-link">
                    {{value.name}}<i class="el-icon-caret-bottom el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="v" v-for="(v,i) in value.threes" :key="i">
                      {{v.name}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </span>
          </div>
        </li>
      </ul>
    </div>
    <div v-else class="load">
      <i class="el-icon-loading"></i>
    </div>
    <el-dialog title="公告" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <span v-html="content">
      </span>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        status: false,
        all_data: null,
        announcements: [],
        dialogVisible: false,
        content: ''
      }
    },
    created() {
      this.request_data()
      this.request_announcements_data()
    },
    methods: {
      // 打开公告详情
      open_announcement(c) {
        this.content = c
        this.dialogVisible = true
      },
      handleClose(done) {
        done()
      },
      // 点击连接
      link(value) {
        if (value.type && [3, 4].indexOf(value.type) != -1) {
          window.open(`/reslink?code=${value.id}`);
        } else {
          sessionStorage.setItem(value.id, 4);
          window.open(`/resource?code=${value.id}`);
          // sessionStorage.setItem(index, 4)
          // window.open(`/resource?code=${index}`)
          // if (localStorage.getItem("crx_versions") != "2"){
          //    this.$confirm('插件版本已更新至稳定版v2024.10.29,请及时下载替换! 如已安装请忽略!', '提示', {
          //       confirmButtonText: '确定/忽略',
          //       cancelButtonText: '不再提示',
          //       type: 'warning'
          //     }).then(() => {
          //       sessionStorage.setItem(index, 4)
          //       window.open(`/resource?code=${index}`)
          //     }).catch(() => { 
          //       localStorage.setItem("crx_versions", "2")   
          //       sessionStorage.setItem(index, 4)
          //       window.open(`/resource?code=${index}`) 
          //     });
          // }else{
          //   sessionStorage.setItem(index, 4)
          //   window.open(`/resource?code=${index}`)
          // }
        }
      },
      // 提示显示
      error_mess() {
        this.$message({
          message: '获取发生错误',
          type: 'error',
          customClass: 'hint-message',
          center: true
        });
      },

      // 请求数据
      request_data() {
        this.$http.getMainData().then(response => {
          if (response.code === 200) {
            this.all_data = response.data;
            this.status = true
          } else {
            this.error_mess()
          }
        }).catch(err => {
          this.error_mess()
        })
      },
      // 请求公告数据
      request_announcements_data() {
        this.$http.getAnnouncements().then(res => {
          this.announcements = res.data
        }).catch(err => {
          console.log(err, 'err')
        })
      }
    }
  }
</script>
<style scoped>
  .main {
    width: 1030px;
    margin: 0 auto;
  }

  .notice {
    text-align: center;
    font-size: 16px;
    padding-top: 20px;
  }

  .blue {
    color: #0044DD;
  }

  .purple {
    color: #800080;
    text-decoration: underline;
  }

  .database {
    font-size: 16px;
    margin-top: 20px;
    padding-bottom: 10px;
  }

  .database p {
    text-align: center;
  }

  .grouping {
    background-color: #6BA2C0;
    padding: 6px 0;
    color: #fff;
  }

  .dbs {
    padding-right: 20px;
    padding-bottom: 10px;
  }

  .menu {
    width: 232px;
    box-sizing: border-box;
    color: #333;
    display: inline-block;
    vertical-align: top;
    text-align: center;
    text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);
    background-image: linear-gradient(to bottom, #ffffff, #e6e6e6);
    border: 1px solid #ccc;
    background-color: #f5f5f5;
    border-radius: 4px;
    margin: 10px 0 0px 20px;
    cursor: pointer;
    border-bottom-color: #b3b3b3;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .2), 0 1px 2px rgba(0, 0, 0, .05);
    white-space: nowrap;
    touch-action: manipulation;
  }

  .link {
    padding: 5.5px 12px;
  }

  .menu:hover {
    cursor: pointer;
    color: #333 !important;
    background-image: linear-gradient(to bottom, #e0e0e0, #eee);
  }

  .menu >>> .el-dropdown-selfdefine {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    width: 232px;
  }

  .el-dropdown-menu__item:hover {
    background-color: #0088cc !important;
    color: #fff !important;
  }

  .load {
    height: calc(100vh - 300px);
    font-size: 40px;
    text-align: center;
    line-height: calc(100vh - 300px);
    color: #666;
  }
</style>
